import React from 'react';
import { isEmpty, omit } from 'ramda';
import { Form } from 'antd';
import api from '../../../config/api';
import { useModel } from '../../../components/use';
import { generators, network, asserts } from '../../../utils';
import Selection from '../../../components/common/Selection';
import { message } from '../../../components/biz';
import './index.less';

const { Item } = Form;
const { generatorArray, generatorObject } = generators;
const formStyle = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 18,
  },
};

const initialState = {
  standard: [],
  diameter: [],
  length: [],
  material: [],
  warehouse: [],
  initialValue: {},
};

const effects = {
  querySelection: async ({ payload, dispatch }) => {
    const { params, form } = payload;
    const { getFieldsValue, setFields } = form;
    const invalidKey = Object.keys(params).filter((item) => !asserts.isExist(params[item]));
    const queryParams = omit(invalidKey, Object.assign({}, params));
    const res = await network({
      url: api.industries.selection,
      method: 'get',
      params: queryParams,
    });
    if (res.success) {
      if (!res.data.success) {
        message.error(generatorObject(res.data).message);
        return;
      }
      const { data = {} } = generatorObject(res.data);
      const standard = generatorArray(data.catList);
      const length = generatorArray(data.lengthList);
      const warehouse = generatorArray(data.custWhList);
      const material = generatorArray(data.materialList);
      const diameter = generatorArray(data.diameterList);
      dispatch('updateState')({
        standard,
        length,
        material,
        diameter,
        warehouse,
      });
      Object.keys(getFieldsValue()).forEach((item) => {
        setFields({ [item]: { value: params[item] } });
      });
    }
  },
  // 2021.11.17 行业专区标准下拉列表接口替换
  queryIndustrySelection: async ({ payload, dispatch }) => {
    const { params, form } = payload;
    const { getFieldsValue, setFields } = form;
    const invalidKey = Object.keys(params).filter((item) => !asserts.isExist(params[item]));
    const queryParams = omit(invalidKey, Object.assign({}, params));
    const res = await network({
      url: api.industries.selection,
      method: 'get',
      params: queryParams,
    });
    if (res.success) {
      const { data = {} } = generatorObject(res.data);
      if (data) {
        const standard = generatorArray(data.standardList);
        const length = generatorArray(data.lengthList);
        const warehouse = generatorArray(data.custWhList);
        const material = generatorArray(data.materialList);
        const diameter = generatorArray(data.diameterList);
        dispatch('updateState')({
          standard,
          length,
          material,
          diameter,
          warehouse,
        });
        Object.keys(getFieldsValue()).forEach((item) => {
          setFields({ [item]: { value: params[item] } });
        });
      } else {
        dispatch('updateState')({
          standard: [],
          length: [],
          material: [],
          diameter: [],
          warehouse: [],
        });
      }
    }
  },
  querySpecialSelection: async ({ payload, dispatch }) => {
    const { params, form } = payload;
    const { getFieldsValue, setFields } = form;
    const invalidKey = Object.keys(params).filter((item) => !asserts.isExist(params[item]));
    const queryParams = omit(invalidKey, Object.assign({}, params));
    const res = await network({
      url: api.sales.condition,
      method: 'get',
      params: {
        ibsrp7: queryParams && queryParams.ibsrp7,
        siCode: queryParams && queryParams.siCode,
        linkConfCode: queryParams && queryParams.linkConfCode,
      },
    });
    if (res.success) {
      if (!res.data.success) {
        message.error(generatorObject(res.data).message);
        return;
      }
      const { data = {} } = generatorObject(res.data);
      const standard = generatorArray(data.standardList);
      const length = generatorArray(data.lengthList);
      const warehouse = generatorArray(data.custWhList);
      const material = generatorArray(data.materialList);
      const diameter = generatorArray(data.diameterList);
      dispatch('updateState')({
        standard,
        length,
        material,
        diameter,
        warehouse,
      });
      Object.keys(getFieldsValue()).forEach((item) => {
        setFields({ [item]: { value: params[item] } });
      });
    }
  },
};
const updateState = (state, payload) => ({ ...state, ...payload });

export default ({ values, isSpecialOffer, isIndustryZone, form }) => {
  const { state, loading, dispatch } = useModel({
    state: initialState,
    effects,
    reducers: { updateState },
  });
  const { standard, diameter, length, material, warehouse, initialValue } = state;
  const { getFieldDecorator, getFieldsValue, setFields, resetFields } = form;
  const { siCode = '', proCode = '' } = values;
  const handleStandardChange = (value) => {
    const fields = Object.keys(getFieldsValue()).filter((item) => item !== 'ibsrp7');
    fields.forEach((item) => setFields({ [item]: { value: '' } }));
    const quParm = {
      params: { ...initialValue, ...getFieldsValue(), ibsrp7: value, siCode },
      form,
    };
    isSpecialOffer
      ? dispatch('querySpecialSelection')(quParm)
      : isIndustryZone
      ? dispatch('queryIndustrySelection')({ ...quParm, proCode })
      : dispatch('querySelection')(quParm);
  };

  // scatId: 大类
  // pcatId: 小类
  // ibsrp7: 标准
  // ibsrp3Dl01: 材质
  // imseg6Dl01: 直径
  // imseg7Dl01: 长度
  React.useEffect(() => {
    resetFields();
    if (!isEmpty(values)) {
      dispatch('updateState')({ initialValue: values });
      isSpecialOffer
        ? dispatch('querySpecialSelection')({ params: values, form })
        : isIndustryZone
        ? dispatch('queryIndustrySelection')({ params: values, form })
        : dispatch('querySelection')({ params: values, form });
    }
  }, [values, isSpecialOffer, isIndustryZone]); //eslint-disable-line

  return (
    <Form layout="inline" {...formStyle} className="selectionForm">
      <Item label="标准">
        {getFieldDecorator('ibsrp7')(
          <Selection
            source={
              values && values.ibsrp7 && values.ibsrp7.trim()
                ? isSpecialOffer
                  ? standard.filter(({ code }) => code === values.ibsrp7)
                  : standard.filter(({ catCode }) => catCode === values.ibsrp7)
                : standard
            }
            placeholder="请选择"
            // loading={loading['querySelection']}
            loading={loading['queryIndustrySelection']}
            transfer={{
              key: isSpecialOffer || isIndustryZone ? 'code' : 'catCode',
              code: isSpecialOffer || isIndustryZone ? 'code' : 'catCode',
              name: isSpecialOffer || isIndustryZone ? 'name' : 'catName',
            }}
            onChange={handleStandardChange}
          />,
        )}
      </Item>

      <Item label="直径">
        {getFieldDecorator('imseg6Dl01')(
          <Selection
            source={
              values && values.imseg6Dl01 && values.imseg6Dl01.trim()
                ? diameter.filter((item) => item === values.imseg6Dl01)
                : diameter
            }
            placeholder="请选择"
            // loading={loading['querySelection']}
            loading={loading['queryIndustrySelection']}
          />,
        )}
      </Item>

      <Item label="长度">
        {getFieldDecorator('imseg7Dl01')(
          <Selection
            source={
              values && values.imseg7Dl01 && values.imseg7Dl01.trim()
                ? length.filter((item) => item === values.imseg7Dl01)
                : length
            }
            placeholder="请选择"
            // loading={loading['querySelection']}
            loading={loading['queryIndustrySelection']}
          />,
        )}
      </Item>

      <Item label="材质">
        {getFieldDecorator('ibsrp3Dl01')(
          <Selection
            source={
              values && values.ibsrp3Dl01 && values.ibsrp3Dl01.trim()
                ? material.filter((item) => item === values.ibsrp3Dl01)
                : material
            }
            placeholder="请选择"
            // loading={loading['querySelection']}
            loading={loading['queryIndustrySelection']}
          />,
        )}
      </Item>

      <Item label="仓别">
        {getFieldDecorator(isSpecialOffer ? 'mmcu' : 'ibmcu')(
          <Selection
            source={warehouse}
            placeholder="请选择"
            // loading={loading['querySelection']}
            loading={loading['queryIndustrySelection']}
            transfer={{ key: 'cwhId', code: 'aamcu', name: 'mcdl01' }}
          />,
        )}
      </Item>
    </Form>
  );
};
